import { makeStyles, shorthands } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const CASE_STUDY_IFRAME_MIN_HEIGHT = "600px";

export const useRetrospectiveCaseStudyPanelStyles = makeStyles({
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    flexShrink: 0,
    marginBottom: designTokens.spacing[4],
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    ...shorthands.borderRadius(designTokens.borderRadius.md),
    backgroundColor: projectIqTokens.card,
    boxShadow: projectIqTokens.shadowSm,
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
    flexShrink: 0,
  },
  hiddenFileInput: {
    display: "none",
  },
  uploadPrompt: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: designTokens.spacing[4],
    height: "100%",
    color: projectIqTokens.muted,
    textAlign: "center",
  },
  uploadButtonRow: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
  errorText: {
    fontSize: designTokens.fontSize.sm,
    color: designTokens.semantic.error,
  },
  iframe: {
    flex: 1,
    border: "none",
    width: "100%",
    height: "100%",
    minHeight: CASE_STUDY_IFRAME_MIN_HEIGHT,
    borderRadius: designTokens.borderRadius.lg,
    backgroundColor: designTokens.neutral.white,
  },
  fileIconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "34px",
    height: "34px",
    ...shorthands.borderRadius(designTokens.borderRadius.md),
    flexShrink: 0,
    backgroundColor: projectIqTokens.bg2,
    color: projectIqTokens.ink3,
  },
  fileInfo: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minWidth: 0,
  },
  fileName: {
    fontSize: "13.5px",
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.ink2,
    whiteSpace: "nowrap",
    ...shorthands.overflow("hidden"),
    textOverflow: "ellipsis",
    margin: 0,
  },
  fileMeta: {
    fontSize: designTokens.fontSize.xs,
    color: projectIqTokens.ink3,
    margin: 0,
  },
  loadingContainer: {
    flex: 1,
    minHeight: "50vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  centeredState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: designTokens.spacing[3],
    height: "100%",
    color: projectIqTokens.muted,
    textAlign: "center",
  },
  stateHeading: {
    fontSize: designTokens.fontSize.base,
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.ink,
  },
  stateBody: {
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.ink3,
  },
});
